import React from 'react'
import styles from './section.module.css'

export default ({ variant, children, classNames }) => (
  <section className={getClassName(variant, classNames)}>
    {children}
  </section>
)

function getClassName(variant, customClassNames) {
  let classNames = [styles.section];

  if (variant === 'green') {
    classNames.push(styles.green);
  } else if (variant === 'black') {
    classNames.push(styles.black);
  }

  if (!!customClassNames) {
    classNames.push(customClassNames);
  }

  return classNames.join(' ');
}
